import React, { useState } from "react";
import { Button, Modal, Form } from "react-bootstrap";
import API from "../../../api";
import { toast } from "react-toastify";
import moment from "moment";

function formatDate(d) {
    if (!d) return "—";
    return moment.utc(d, "YYYY-MM-DD").format("ll");
}

export default function EditReviewnModal({ lesson, onClose, onUpdated, onDeleted }) {
    const [text, setText] = useState(lesson?.notes || "");
    const [submitting, setSubmitting] = useState(false);
    const [deleting, setDeleting] = useState(false);

    const save = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        try {
            const { data } = await API.put(`reviews/${lesson.id}`, {
                notes: text,
                accountId: lesson.accountId,
            });
            toast.success("Successfully updated lesson");
            onUpdated(data || { ...lesson, notes: text });
        } catch (e) {
            toast.error("Could not update lesson");
        } finally {
            setSubmitting(false);
        }
    };

    const destroy = async () => {
        if (!window.confirm("Delete this lesson? This cannot be undone.")) return;
        setDeleting(true);
        try {
            await API.delete(`reviews/${lesson.id}`);
            toast.success("Successfully deleted lesson");
            onDeleted(lesson.id);
        } catch (e) {
            toast.error("Could not delete lesson");
            setDeleting(false);
        }
    };

    return (
        <Modal show onHide={onClose} backdrop="static" centered>
            <Form onSubmit={save}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Lesson</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mb-2">
                        <div>
                            <strong>Status:</strong>{" "}
                            <span className={lesson.status === "complete" ? "text-success" : "text-danger"}>
                {lesson.status === "complete" ? "Completed" : "Pending"}
              </span>
                        </div>
                        <div>
                            <strong>Submitted:</strong> {formatDate(lesson.created_at)}
                        </div>
                        <div>
                            <strong>Updated:</strong> {formatDate(lesson.updated_at)}
                        </div>
                    </div>
                    <Form.Label>Notes for Instructor</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={4}
                        value={text}
                        onChange={(e) => setText(e.target.value)}
                        placeholder="Enter your comment…"
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="danger"
                        onClick={destroy}
                        disabled={deleting || submitting}
                    >
                        {deleting ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-1" /> Deleting…
                            </>
                        ) : (
                            "Delete Lesson"
                        )}
                    </Button>
                    <Button
                        type="submit"
                        variant="primary"
                        disabled={submitting || deleting}
                    >
                        {submitting ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-1" /> Saving…
                            </>
                        ) : (
                            "Update Lesson"
                        )}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}
